import { clsx } from "clsx";
import React, { useMemo, useState } from "react";
import { FaX } from "react-icons/fa6";
import { deployCountries, PH_SOCIAL_MEDIAS, SOCIAL_MEDIA_TYPE, TH_SOCIAL_MEDIAS } from "src/main/contants";
import { getDeployEnv, SimpleMap } from "src/main/utils";
import FloatingButton from "src/main/views/component/FloatingButton";

interface SocialType {
  type: string;
  url: string;
}

const SOCIAL_NETWORKS: SimpleMap<SocialType[]> = {
  [deployCountries.PH]: [
    { type: SOCIAL_MEDIA_TYPE.Telegram, url: PH_SOCIAL_MEDIAS.Telegram },
    { type: SOCIAL_MEDIA_TYPE.Messenger, url: PH_SOCIAL_MEDIAS.Messenger },
  ],
  [deployCountries.TH]: [{ type: SOCIAL_MEDIA_TYPE.LINE, url: TH_SOCIAL_MEDIAS.LINE }],
};

const SOCIAL_ICON_MAP = {
  [SOCIAL_MEDIA_TYPE.LINE]: "/images/icon/fab-line.svg",
  [SOCIAL_MEDIA_TYPE.Telegram]: "/images/icon/fab-telegram.svg",
  [SOCIAL_MEDIA_TYPE.Messenger]: "/images/icon/fab-messenger.svg",
};

const SocialMediaLink: React.FC<SocialMediaLinkProps> = () => {
  const [isExpanded1, setIsExpanded1] = useState(false);
  const [isExpanded2, setIsExpanded2] = useState(false);
  const [showIcons1, setShowIcons1] = useState(false);
  const [showIcons2, setShowIcons2] = useState(false);

  const currentEnv = getDeployEnv();

  function handleToggle() {
    setIsExpanded1((prevIsExpanded1) => !prevIsExpanded1);
    setTimeout(() => {
      setShowIcons1(!showIcons1);
      setTimeout(() => {
        setIsExpanded2(!isExpanded2);
        setTimeout(() => {
          setShowIcons2(!showIcons2);
        }, 10);
      }, 10);
    }, 10);
  }

  const socialNetworkButtons = useMemo(() => {
    if (!isExpanded1) return null;
    const currentSocialNetworks: SocialType[] = currentEnv?.country_iso ? SOCIAL_NETWORKS[currentEnv.country_iso] : [];

    return currentSocialNetworks.map((socialNetwork, index) => (
      <FloatingButton
        className={clsx("transform cursor-pointer bg-white duration-300 ease-in-out", `delay-${100 * (index + 1)}`, {
          "translate-y-0 opacity-100": showIcons1,
          "translate-y-10 opacity-0": !showIcons1,
        })}
        imgSrc={SOCIAL_ICON_MAP[socialNetwork.type]}
        onClick={() => {
          window.open(socialNetwork.url, "_blank");
        }}
        key={socialNetwork.type}
        alt={socialNetwork.type}
      />
    ));
  }, [currentEnv.country_iso, isExpanded1, showIcons1]);

  return (
    <>
      <div className="mt-2 flex flex-col items-start space-y-2">{socialNetworkButtons}</div>
      {showIcons1 && (
        <FloatingButton
          className="mt-2 bg-black"
          onClick={handleToggle}
        >
          <FaX
            color="currentColor"
            className="inline-block text-gray-400"
          />
        </FloatingButton>
      )}
      {!showIcons1 && (
        <FloatingButton
          className="bg-black !p-2"
          onClick={handleToggle}
          imgSrc="/images/icon/fab-chat.svg"
        >
          <div className="absolute right-0.5 top-0.5 h-4 w-4 rounded-full bg-black" />
          <div className="absolute right-[5px] top-[5px] h-2 w-2 animate-scale-pulse rounded-full border-[3px] border-transparent bg-[#39FF14] drop-shadow-[0_0_6px_#39FF14] filter" />
        </FloatingButton>
      )}
    </>
  );
};

export default SocialMediaLink;

interface SocialMediaLinkProps {}
